module.exports = __webpack_public_path__ + "/images/ico-color-success.a4d4a9a.svg";